module.exports = __webpack_public_path__ + "img/tui2.b0e43750.png";